<div
  class="bg-white rounded-lg shadow-xl w-full max-w-full sm:max-w-2xl md:max-w-4xl lg:max-w-5xl max-h-[calc(100vh-env(safe-area-inset-bottom))] sm:max-h-[90vh] overflow-y-auto overflow-x-hidden animate-scale-in scroll-smooth"
  style="-webkit-overflow-scrolling: touch;">
  <div class="text-white p-4 sm:p-6"
    [ngClass]="isRequestApproal ? 'bg-gradient-to-r from-orange-300 via-orange-300 to-orange-300' : 'bg-gradient-to-r from-blue-600 to-blue-700'">
    <div class="flex justify-between items-start mb-3 sm:mb-4">
      <div class="flex items-center flex-1 min-w-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-calendar mr-2 sm:mr-3 flex-shrink-0">
          <path d="M8 2v4"></path>
          <path d="M16 2v4"></path>
          <rect width="18" height="18" x="3" y="4" rx="2"></rect>
          <path d="M3 10h18"></path>
        </svg>
        <h2 class="text-lg sm:text-xl font-bold truncate mb-0">
          {{ (finishAssignmentData?.startAt | date:'MMMM d, yyyy') | titlecase }}
        </h2>
      </div>
      <button (click)="closeModal()" class="text-white hover:text-gray-200 transition-colors p-1 ml-2 focus:outline-none outline-none"
        aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>
    </div>
    <div class="flex items-center mb-3 min-w-0">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-map-pin mr-2">
        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
        </path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      <h3 class="text-base sm:text-lg font-semibold truncate mb-0">
        {{finishAssignmentData?.jobPlace?.jobPlaceName ? finishAssignmentData?.jobPlace?.jobPlaceName : '-' }}
      </h3>
    </div>
    <div class="flex items-center">
      <div class="flex items-center px-2 sm:px-3 py-1 rounded-full"
        [ngClass]="isRequestApproal ? 'bg-orange-100 text-orange-800' : 'bg-[rgba(255,255,255,.2)] text-white'">
        @if(isRequestApproal) {
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1.5">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-circle-check-big mr-1.5">
          <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
          <path d="m9 11 3 3L22 4"></path>
        </svg>
        }
        <span class="text-sm font-medium">{{ displayStatus(finishAssignmentData?.status) }}</span>
      </div>
    </div>
  </div>

  <div class="grid gap-4 p-6 bg-gray-50 border-b border-gray-200" [ngClass]="customer?.employeeRole?.id != 3 
    ? 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4' 
    : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3'">
    @if(customer?.employeeRole?.id != 3)
    {
    <div
      class="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:scale-105 transition-all duration-300 group">
      <div class="flex items-center text-gray-500 mb-3">
        <div
          class="p-2 bg-green-100 rounded-lg mr-3 group-hover:bg-green-200 transition-colors flex items-center justify-center w-[34px] h-[34px]">
          <span class="text-green-600 font-bold text-sm">kr</span>
        </div>
        <span class="text-sm font-medium">{{ 'guard-shift-details.finish.total-cost' | translate }}</span>
      </div>
      <div class="text-2xl font-bold text-gray-800 group-hover:text-green-600 transition-colors">
        {{ calculatTotalCost }}
      </div>
    </div>
    }
    <div
      class="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:scale-105 transition-all duration-300 group">
      <div class="flex items-center text-gray-500 mb-3">
        <div class="p-2 bg-blue-100 rounded-lg mr-3 group-hover:bg-blue-200 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-clock text-blue-600">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <span class="text-sm font-medium">{{ 'guard-shift-details.finish.total-time' | translate }}</span>
      </div>
      <div class="text-2xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
        <div class="text-2xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
          @if (getTotalHoursForShift() > 0) {
            {{ getTotalHoursForShift() | number:'1.2-2' }}h
          } @else {
            -
          }
        </div>

      </div>
    </div>

    <div
      class="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:scale-105 transition-all duration-300 group">
      <div class="flex items-center text-gray-500 mb-3">
        <div class="p-2 bg-purple-100 rounded-lg mr-3 group-hover:bg-purple-200 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-users text-purple-600">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <span class="text-sm font-medium">{{ 'guard-shift-details.finish.added-guard' | translate }}</span>
      </div>
      <div class="text-2xl font-bold text-gray-800 group-hover:text-purple-600 transition-colors">
        {{ finishAssignmentData?.guardsNumber ? finishAssignmentData?.guardsNumber : '-' }}</div>
    </div>
    <div
      class="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-lg hover:scale-105 transition-all duration-300 group">
      <div class="flex items-center text-gray-500 mb-3">
        <div class="p-2 bg-amber-100 rounded-lg mr-3 group-hover:bg-amber-200 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-check-check text-amber-600">
            <path d="M18 6 7 17l-5-5"></path>
            <path d="m22 10-7.5 7.5L13 16"></path>
          </svg>
        </div>
        <span class="text-sm font-medium">{{ 'guard-shift-details.finish.punctuality' | translate }}</span>
      </div>
      <div class="text-2xl font-bold text-gray-800 group-hover:text-amber-600 transition-colors">
        {{ finishAssignmentData?.punctualityOfGuards ? finishAssignmentData?.punctualityOfGuards + '%' : '-' }}
      </div>
    </div>
  </div>

  <div class="p-4 sm:p-6 bg-gray-50">
    @if (finishAssignmentData?.description) {
    <h3 class="text-lg font-semibold text-gray-800 mb-6 flex items-center">
      <i class="p-2 bg-blue-100 rounded-lg mr-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-file-text text-blue-600">
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M10 9H8"></path>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
        </svg>
      </i>
      <span>{{ 'guard-shift-details.finish.mission-summary' | translate }}</span>
    </h3>

    <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6 hover:shadow-md transition-shadow">
      <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
        <span class="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
        {{ 'guard-shift-details.finish.description' | translate }}
      </h4>

      <p class="text-gray-600 leading-relaxed mb-0 break-words whitespace-pre-wrap">
        {{ finishAssignmentData?.description ? finishAssignmentData?.description : '-' }}
      </p>
    </div>
    }

    <div class="">
      <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users mr-2 text-blue-600">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>{{'guard-shift-details.finish.guard-staffing' | translate}}
      </h3>
      <div class="overflow-hidden rounded-lg border border-gray-200 shadow-sm mb-6">
        <div class="mb-6 last:mb-0 sm:overflow-auto w-full">
          <div class="bg-gradient-to-r from-blue-50 to-blue-100 px-4 py-3 border-b border-gray-200 w-full">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div class="flex items-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock text-blue-600 mr-2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <h4 class="font-medium text-blue-800 m-0">{{'guard-shift-details.finish.shift' | translate}}:
                  @if(finishAssignmentData?.startAt)
                  {
                  {{finishAssignmentData?.startTime}} - {{finishAssignmentData?.endTime}}
                  }
                </h4>

              </div>
              <div class="flex flex-wrap items-center gap-3 text-sm">

                <div class="text-gray-600">
                  @if (getTotalHoursForShift() > 0) {
                  <span class="font-medium">
                    {{ getTotalHoursForShift() | number:'1.2-2' }}h
                  </span>
                  {{ 'guard-shift-details.finish.total' | translate }}
                  } @else {
                  <span>-</span>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile view -->
          <div class="block sm:hidden">
            @if(finishAssignmentData?.hired?.length > 0 )
            {
            @for(data of finishAssignmentData.hired; track (data?.id ? data.id + '-' + $index : $index))
            {
            <div class="p-4 border-b border-gray-100 bg-white">
              <div class="flex flex-col md:flex-row items-start justify-between mb-3 gap-2">
                <div class="flex items-center flex-1">
                  @if(data?.image) {
                  <img *ngIf="data?.image" else fallbackImage [src]="data?.image" alt="guard-image"
                    class="w-8 h-8 rounded-full mr-3 flex items-center justify-center cursor-pointer"
                    (click)="openGuardDetailsModal(data)" loading="lazy" />
                  } @else {
                  <div
                    class="w-10 h-10 rounded-full mr-3 object-cover bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center border-2 border-blue-300 cursor-pointer"
                    (click)="openGuardDetailsModal(data)">
                    <div class="text-blue-700 font-bold text-sm"> {{ (data?.aliasName?.charAt(0) ||
                      data?.firstName?.charAt(0)) || '-' }}</div>
                  </div>
                  }
                  <div>
                    <div class="text-sm font-medium text-gray-900 cursor-pointer" (click)="openGuardDetailsModal(data)">
                      {{ (data?.aliasName ? data.aliasName : (data?.firstName ? data.firstName : '-')) }}
                    </div>
                    <div class="text-xs text-gray-600">
                      <div class="text-sm text-gray-900">
                        {{ finishAssignmentData?.skill?.name ? finishAssignmentData?.skill?.name : '-'}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="whitespace-nowrap">
                  @if(showCorrectionPopup && overtimeGuardData?.id === data.id) {
                  <!-- Editing - Redigerar (Mobile) -->
                  <div class="flex items-center">
                    <span
                      class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-blue-100 text-blue-800">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mr-1">
                        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path>
                        <path d="m15 5 4 4"></path>
                      </svg>
                      {{'guard-shift-details.finish.editing' | translate}}
                    </span>
                  </div>
                  } @else if(data?.shiftDetails?.status==301) {
                  <!-- Overtime Approved - Attesterad (Mobile) -->
                  <div class="flex items-center">
                    <span
                      class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mr-1">
                        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                        <path d="m9 11 3 3L22 4"></path>
                      </svg>
                      {{'guard-shift-details.finish.attested' | translate}}
                    </span>
                  </div>
                  } @else if(data?.shiftDetails?.status==commonConstants.CUSTOMER_DISAPPROVE_HOURS) {
                  <!-- Overtime Rejected - Avvisad (Mobile) -->
                  <div class="flex items-center">
                    <span
                      class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-red-100 text-red-800 cursor-pointer hover:bg-red-200 transition-colors rejected-badge"
                      [attr.data-guard-id]="data.id" (click)="openRejectionPopupForGuard(data, $event)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mr-1 pointer-events-none">
                        <path d="M18 6 6 18"></path>
                        <path d="M6 6 18 18"></path>
                      </svg>
                      {{'guard-shift-details.finish.rejected' | translate}}
                    </span>
                  </div>
                  } @else if(data?.shiftDetails?.overtimePendingApproval==1) {
                  <!-- Attestera button for overtime (Mobile) -->
                  <button
                    class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-amber-100 text-amber-800 hover:bg-amber-200 transition-all duration-300 border border-amber-300"
                    (click)="showApproveOvertimeConfirm(data, $event)" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="mr-1">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    {{ 'guard-shift-details.finish.attestera' | translate }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="ml-1">
                      <path d="m9 18 6-6-6-6"></path>
                    </svg>
                  </button>
                  } @else if (!data.shiftDetails?.checkinTime || !finishAssignmentData?.startTime) {
                  <!-- Show dash if missing or blank -->
                  <span style="margin: 15px;">–</span>
                  } @else if (isGuardLate(data.shiftDetails, finishAssignmentData.startTime)) {
                  <!-- Late -->
                  <div class="flex items-center">
                    <span
                      class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-amber-100 text-amber-800">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-circle-alert mr-[1px]">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" x2="12" y1="8" y2="12"></line>
                        <line x1="12" x2="12.01" y1="16" y2="16"></line>
                      </svg>
                      {{'guard-shift-details.finish.late' | translate}}
                    </span>
                  </div>
                  } @else {
                  <!-- On time -->
                  <div class="flex items-center">
                    <span
                      class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mr-1">
                        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                        <path d="m9 11 3 3L22 4"></path>
                      </svg>
                      {{'guard-shift-details.finish.on-time' | translate}}
                    </span>
                  </div>
                  }
                </div>

              </div>
              <div class="grid grid-cols-3 gap-2 text-xs mb-3">
                <div>
                  <span class="text-gray-500 block">{{'guard-shift-details.finish.check-in' | translate}}</span>
                  <span class="font-medium">
                    {{ data?.shiftDetails?.checkinTime ? (data.shiftDetails.checkinTime | date: 'HH:mm') : '-' }}
                  </span>
                </div>
                <div>
                  <span class="text-gray-500 block">{{'guard-shift-details.finish.check-out' | translate}}</span>
                  <span class="font-medium">
                    {{ data?.shiftDetails?.checkoutTime ? (data.shiftDetails.checkoutTime | date: 'HH:mm') : '-' }}
                  </span>
                </div>
                <div>
                  <span class="text-gray-500 block">{{'guard-shift-details.finish.hours' | translate}}</span>
                  <span class="font-medium">
                    {{ calculateDuration(data?.shiftDetails?.checkinTime, data?.shiftDetails?.checkoutTime) }}
                  </span>
                </div>
              </div>
              <div class="flex items-center justify-center space-x-3">
                <!-- ⭐ Star (Outstanding Guard) -->
                <button
                  class="w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 group relative bg-amber-100 cursor-pointer hover:bg-amber-200"
                  (click)="handleStarGuard(data.id, $event)"
                  [matTooltip]="data.isRatedByCustomerForShift ? ('guard-shift-details.finish.rating-already-given' | translate) : ('guard-shift-details.finish.outstanding-guard' | translate)"
                  matTooltipPosition="above" type="button" (click)="tooltip.show()"
                  [disabled]="data.isRatedByCustomerForShift"
                  [attr.aria-pressed]="data.isRatedByCustomerForShift ? 'true' : 'false'"
                  [ngClass]="{'bg-gray-200 cursor-not-allowed opacity-60 hover:bg-gray-200': data.isRatedByCustomerForShift}"
                  aria-label="Markera som enastående vakt (5 stjärnor)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    [ngClass]="{'text-amber-600 fill-amber-600': data.isRatedByCustomerForShift, 'text-amber-500 fill-none group-hover:text-amber-700': !data.isRatedByCustomerForShift}"
                    class="transition-all duration-300">
                    <polygon
                      points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                    </polygon>
                  </svg>

                  <!-- Confetti on success -->
                  <ngx-confetti-explosion *ngIf="showConfetti && lastRatedGuardId === data.id">
                  </ngx-confetti-explosion>
                </button>

                <!-- 💬 Comment -->
                <button
                  class="w-7 h-7 flex items-center justify-center rounded-full bg-blue-100 cursor-pointer transition-all duration-300 group relative hover:bg-blue-200"
                  title="" (click)="openCommentModal(data)"
                  [matTooltip]="'guard-shift-details.finish.leave-comment' | translate" matTooltipPosition="above"
                  (click)="tooltip.show()" type="button" aria-pressed="true" aria-label="Lämna specifik feedback">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-blue-600 transition-colors duration-300 group-hover:text-blue-700">
                    <path d="M7 10v12"></path>
                    <path
                      d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                    </path>
                  </svg>
                </button>
                <!-- cancel block user button -->
                <button
                  class="w-7 h-7 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 group relative"
                  type="button" (click)="openCancelModal(data)" [matTooltip]="data.isCustomerBlockedToGuard 
    ? ('guard-shift-details.finish.already-blocked-guard' | translate) 
    : ('guard-shift-details.finish.block-user' | translate)" matTooltipPosition="above" #tooltip="matTooltip"
                  [disabled]="data.isCustomerBlockedToGuard"
                  [attr.aria-pressed]="data.isCustomerBlockedToGuard ? 'true' : 'false'" [ngClass]="{
    'bg-amber-100 hover:bg-amber-200': !data.isCustomerBlockedToGuard,
    'bg-gray-200 cursor-not-allowed opacity-60 hover:bg-gray-200': data.isCustomerBlockedToGuard
  }" aria-label="Remove from all shifts and block guard">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-gray-400 transition-colors duration-300 group-hover:text-red-600">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="m15 9-6 6"></path>
                    <path d="m9 9 6 6"></path>
                  </svg>
                </button>

              </div>
            </div>
            }
            } @else {
            <p> {{ 'guard-shift-details.finish.data-not-found' | translate }}</p>
            }
          </div>

          <!-- Desktop -->
          <div class="hidden sm:block">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    @if(finishAssignmentData?.hired?.length === 1) {
                    {{ 'guard-shift-details.finish.user' | translate }}
                    } @else {
                    {{ 'guard-shift-details.finish.users' | translate }}
                    }
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ 'guard-shift-details.finish.roll' | translate }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ 'guard-shift-details.finish.check-in' | translate }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ 'guard-shift-details.finish.check-out' | translate }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ 'guard-shift-details.finish.hours' | translate }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ 'guard-shift-details.finish.status' | translate }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ 'guard-shift-details.finish.feedback' | translate }}
                  </th>
                </tr>

              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                @if(finishAssignmentData?.hired?.length > 0 )
                {
                @for(data of finishAssignmentData?.hired; track (data?.id ? data.id + '-' + $index : $index))
                {
                <tr class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap cursor-pointer" (click)="openGuardDetailsModal(data)">
                    <div class="flex items-center">
                      @if(data?.image) {
                      <img *ngIf="data?.image" else fallbackImage [src]="data?.image" alt="guard-image"
                        class="w-8 h-8 rounded-full mr-3 flex items-center justify-center" loading="lazy" />
                      } @else {
                      <div
                        class="w-8 h-8 rounded-full mr-3 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center border-2 border-blue-300">
                        <div class="text-blue-700 font-bold text-sm">
                          {{ (data?.aliasName?.charAt(0) || data?.firstName?.charAt(0)) || '-' }}
                        </div>
                      </div>
                      }
                      <div class="text-sm font-medium text-gray-900">
                        {{ (data?.aliasName ? data.aliasName : (data?.firstName ? data.firstName : '-')) }}
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap relative group">
                    <div class="text-sm text-gray-900 inline-block">
                      {{finishAssignmentData.skill?.name ? finishAssignmentData.skill?.name : '-'}}
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-900">
                      {{ data?.shiftDetails?.checkinTime ? (data.shiftDetails.checkinTime | date: 'HH:mm') : '-' }}
                    </div>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-900">
                      {{ data?.shiftDetails?.checkoutTime ? (data.shiftDetails.checkoutTime | date: 'HH:mm') : '-' }}
                    </div>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm font-medium text-gray-900">
                      {{ calculateDuration(data?.shiftDetails?.checkinTime, data?.shiftDetails?.checkoutTime) }}
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    @if(showCorrectionPopup && overtimeGuardData?.id === data.id) {
                    <!-- Editing - Redigerar -->
                    <div class="flex items-center">
                      <span
                        class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-blue-100 text-blue-800">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-1">
                          <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path>
                          <path d="m15 5 4 4"></path>
                        </svg>
                        {{'guard-shift-details.finish.editing' | translate}}
                      </span>
                    </div>
                    } @else if(data?.shiftDetails?.status==301) {
                    <!-- Overtime Approved - Attesterad -->
                    <div class="flex items-center">
                      <span
                        class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-1">
                          <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                          <path d="m9 11 3 3L22 4"></path>
                        </svg>
                        {{'guard-shift-details.finish.attested' | translate}}
                      </span>
                    </div>
                    } @else if(data?.shiftDetails?.status==302) {
                    <!-- Overtime Rejected - Avvisad -->
                    <div class="flex items-center">
                      <span
                        class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-red-100 text-red-800 cursor-pointer hover:bg-red-200 transition-colors rejected-badge"
                        [attr.data-guard-id]="data.id" (click)="openRejectionPopupForGuard(data, $event)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-1 pointer-events-none">
                          <path d="M18 6 6 18"></path>
                          <path d="M6 6 18 18"></path>
                        </svg>
                        {{'guard-shift-details.finish.rejected' | translate}}
                      </span>
                    </div>
                    } @else if(data?.shiftDetails?.overtimePendingApproval==1) {
                    <!-- Attestera button for overtime -->
                    <button
                      class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full bg-amber-100 text-amber-800 hover:bg-amber-200 transition-all duration-300 border border-amber-300"
                      (click)="showApproveOvertimeConfirm(data, $event)" type="button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mr-1">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      {{ 'guard-shift-details.finish.attestera' | translate }}
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="ml-1">
                        <path d="m9 18 6-6-6-6"></path>
                      </svg>
                    </button>
                    } @else if (!data.shiftDetails?.checkinTime || !finishAssignmentData?.startTime) {
                    <!-- Show dash if missing or blank -->
                    <span>–</span>
                    } @else if (isGuardLate(data.shiftDetails, finishAssignmentData.startTime)) {
                    <!-- Late -->
                    <div class="flex items-center">
                      <span
                        class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-amber-100 text-amber-800">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-circle-alert mr-[1px]">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" x2="12" y1="8" y2="12"></line>
                          <line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                        {{'guard-shift-details.finish.late' | translate}}
                      </span>
                    </div>
                    } @else {
                    <!-- On time -->
                    <div class="flex items-center">
                      <span
                        class="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="mr-1">
                          <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                          <path d="m9 11 3 3L22 4"></path>
                        </svg>
                        {{'guard-shift-details.finish.on-time' | translate}}
                      </span>
                    </div>
                    }

                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center space-x-4 relative">
                      <!-- Star button -->
                      <button
                        class="w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 group relative bg-amber-100 cursor-pointer hover:bg-amber-200"
                        (click)="handleStarGuard(data.id, $event)"
                        [matTooltip]="data.isRatedByCustomerForShift ? ('guard-shift-details.finish.rating-already-given' | translate) : ('guard-shift-details.finish.outstanding-guard' | translate)"
                        matTooltipPosition="above" type="button" [disabled]="data.isRatedByCustomerForShift"
                        [attr.aria-pressed]="data.isRatedByCustomerForShift ? 'true' : 'false'"
                        [ngClass]="{'bg-gray-200 cursor-not-allowed opacity-60 hover:bg-gray-200': data.isRatedByCustomerForShift}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          [ngClass]="{'text-amber-600 fill-amber-600': data.isRatedByCustomerForShift,'text-amber-500 fill-none group-hover:text-amber-700': !data.isRatedByCustomerForShift}"
                          class="transition-all duration-300">
                          <polygon
                            points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>

                        <!-- Confetti on success -->
                        <ngx-confetti-explosion
                          *ngIf="showConfetti && lastRatedGuardId === data.id"></ngx-confetti-explosion>
                      </button>
                      <!-- Comment button -->
                      <button
                        class="w-7 h-7 flex items-center justify-center rounded-full bg-blue-100 cursor-pointer transition-all duration-300 group relative hover:bg-blue-200"
                        title="" (click)="openCommentModal(data)"
                        [matTooltip]="'guard-shift-details.finish.leave-comment' | translate" matTooltipPosition="above"
                        type="button" aria-pressed="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text-blue-600 transition-colors duration-300 group-hover:text-blue-700">
                          <path d="M7 10v12"></path>
                          <path
                            d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                          </path>
                        </svg>
                      </button>
                      <!-- Cancel / Block button -->
                      <button
                        class="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 cursor-pointer transition-all duration-300 group relative hover:bg-red-50"
                        (click)="openCancelModal(data)" title=""
                        [matTooltip]="data.isCustomerBlockedToGuard ? ('guard-shift-details.finish.already-blocked-guard' | translate) : ('guard-shift-details.finish.block-user' | translate)"
                        matTooltipPosition="above" type="button" aria-pressed="true"
                        [disabled]="data.isCustomerBlockedToGuard"
                        [attr.aria-pressed]="data.isCustomerBlockedToGuard ? 'true' : 'false'"
                        [ngClass]="{'bg-amber-100 cursor-pointer hover:bg-amber-200': !data.isCustomerBlockedToGuard, 'bg-gray-200 cursor-not-allowed opacity-60 hover:bg-gray-200': data.isCustomerBlockedToGuard }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="text-gray-400 transition-colors duration-300 group-hover:text-red-600">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="m15 9-6 6"></path>
                          <path d="m9 9 6 6"></path>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                }
                }
                @else
                {
                <tr>
                  <td colspan="7" class="text-center py-4 text-gray-500">
                    {{ 'guard-shift-details.finish.data-not-found' | translate }}
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Time Report / Attestera Popup - Positioned beside button -->
  @if(showOvertimeConfirm) {
  <div class="fixed inset-0 z-[1100]" (click)="cancelOvertimeConfirm()">
    <div
      class="fixed bg-white rounded-lg shadow-xl w-[380px] max-w-[calc(100vw-20px)] max-h-[calc(100vh-40px)] overflow-y-auto border border-gray-200"
      [ngStyle]="{'top.px': popupPosition.top, 'left.px': popupPosition.left}" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="p-[12px] bg-amber-50 border-b border-amber-200">
        <div class="flex items-center justify-between gap-[8px]">
          <div class="flex items-center gap-[6px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-file-text text-amber-700">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
              <path d="M10 9H8"></path>
              <path d="M16 13H8"></path>
              <path d="M16 17H8"></path>
            </svg>

            <span class="text-[14px] font-medium text-amber-800">
              {{ 'guard-shift-details.finish.time-report-from' | translate }} {{ overtimeGuardData?.aliasName ||
              overtimeGuardData?.firstName || '' }}
            </span>
          </div>

          <span class="px-[8px] py-[2px] bg-amber-100 text-amber-700 rounded-full text-[10px] font-semibold">
            {{ 'guard-shift-details.finish.awaiting-attest' | translate }}
          </span>
        </div>
      </div>

      <!-- Content -->
      <div class="p-4">
        <div class="bg-gray-50 rounded-md p-[12px] mb-[16px] border border-gray-200">
          <div class="space-y-[8px]">
            <div class="flex items-center justify-between text-[12px]">
              <span class="text-gray-500">{{ 'guard-shift-details.finish.scheduled' | translate }}:</span>
              <span class="font-medium text-gray-600 tabular-nums">
                {{ finishAssignmentData?.startTime || '-' }} - {{ finishAssignmentData?.endTime || '-' }}
              </span>
            </div>

            <div class="flex items-center justify-between text-[12px]">
              <span class="text-gray-500">{{ 'guard-shift-details.finish.reported' | translate }}:</span>
              <span class="font-semibold text-amber-700 tabular-nums">
                {{ overtimeGuardData?.shiftDetails?.checkinTime ? (overtimeGuardData.shiftDetails.checkinTime | date:
                'H:mm') : '-' }} -
                {{ overtimeGuardData?.shiftDetails?.checkoutTime ? (overtimeGuardData.shiftDetails.checkoutTime | date:
                'H:mm') : '-' }}
              </span>
            </div>
          </div>

          <div class="flex flex-wrap gap-[4px] mt-[8px]">
            @if(isGuardLate(overtimeGuardData?.shiftDetails, finishAssignmentData?.startTime)) {
            <span
              class="inline-flex items-center px-[6px] py-[2px] rounded-full text-[12px] bg-amber-100 text-amber-700">
              {{ 'guard-shift-details.finish.late-prefix' | translate }} {{
              calculateLateMinutes(overtimeGuardData?.shiftDetails, finishAssignmentData?.startTime) }}
            </span>
            }

            @if(calculateOvertimeMinutes(overtimeGuardData?.shiftDetails, finishAssignmentData?.endTime)) {
            <span class="inline-flex items-center px-[6px] py-[2px] rounded-full text-[12px] bg-blue-100 text-blue-700">
              {{ calculateOvertimeMinutes(overtimeGuardData?.shiftDetails, finishAssignmentData?.endTime) }}
            </span>
            }
          </div>
        </div>

        <!-- Explanation Section -->
        @if(overtimeGuardData?.shiftDetails?.adjustTimeReason) {
        <div class="mb-4">
          <div class="flex items-center mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2"
              style="color: #9ca3af;">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            <span class="text-sm" style="color: #6b7280;">{{ 'guard-shift-details.finish.explanation' | translate
              }}:</span>
          </div>
          <div
            class="bg-white rounded-md p-[8px] border border-gray-200 text-[12px] text-gray-700 italic leading-[1.625]">
            "{{ overtimeGuardData?.shiftDetails?.adjustTimeReason }}"
          </div>
        </div>
        }

        <!-- Action Buttons -->
        <div class="flex gap-3 mt-4">
          <button (click)="overtimeConfirmType = 'approve'; confirmOvertimeAction()"
            class="flex-1 inline-flex items-center justify-center px-4 py-2.5 rounded-full font-medium transition-colors shadow-sm"
            style="background: #22c55e; color: white;" onmouseover="this.style.background='#16a34a'"
            onmouseout="this.style.background='#22c55e'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="mr-1.5">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            {{ 'guard-shift-details.finish.approve' | translate }}
          </button>
          <button (click)="overtimeConfirmType = 'reject'; confirmOvertimeAction()"
            class="flex-1 inline-flex items-center justify-center px-4 py-2.5 rounded-full font-medium transition-colors"
            style="background: white; border: 1px solid #d1d5db; color: #6b7280;"
            onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='white'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1.5">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m15 9-6 6"></path>
              <path d="m9 9 6 6"></path>
            </svg>
            {{ 'guard-shift-details.finish.reject' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Rejection Popup - Positioned beside button -->
  @if(showRejectionPopup) {
  <div class="fixed inset-0 z-[1100]" (click)="cancelRejectionPopup()">
    <div role="dialog" tabindex="-1"
      class="fixed rounded-md bg-white border border-gray-200 shadow-xl w-[320px] max-w-[calc(100vw-20px)] max-h-[calc(100vh-40px)] overflow-y-auto"
      [ngStyle]="{'top.px': popupPosition.top, 'left.px': popupPosition.left}" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="p-[12px] bg-red-50 border-b border-red-200">
        <div class="flex items-center justify-between gap-[8px]">
          <div class="flex items-center gap-[8px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-circle-x text-red-600">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m15 9-6 6"></path>
              <path d="m9 9 6 6"></path>
            </svg>

            <span class="text-[14px] font-medium text-red-800">
              {{ 'guard-shift-details.finish.time-report-rejected' | translate }}
            </span>
          </div>
        </div>
      </div>

      <!-- Body -->
      <div class="p-[12px]">
        <button (click)="openCorrectionPopup()" class="w-full px-[12px] py-[8px] text-[12px] font-medium
                   bg-white text-red-700 border border-red-300
                   rounded-md hover:bg-red-50 transition-colors
                   flex items-center justify-center gap-[4px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-file-text">
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
            <path d="M10 9H8"></path>
            <path d="M16 13H8"></path>
            <path d="M16 17H8"></path>
          </svg>
          {{ 'guard-shift-details.finish.correct-time-report' | translate }}
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Correction Popup - Positioned beside button -->
  @if(showCorrectionPopup) {
  <div class="fixed inset-0 z-[1100]">
    <div
      class="fixed bg-white rounded-lg border border-gray-200 shadow-xl w-[320px] max-w-[calc(100vw-20px)] max-h-[calc(100vh-40px)] overflow-y-auto"
      [ngStyle]="{'top.px': popupPosition.top, 'left.px': popupPosition.left}" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="p-[12px] bg-blue-50 border-b border-blue-200">
        <div class="text-[14px] font-medium text-blue-800">
          {{ 'guard-shift-details.finish.correct-time-report' | translate }}
        </div>
      </div>

      <!-- Content -->
      <div class="p-4">
        <!-- Time Inputs -->
        <div class="flex items-end gap-1 mb-4">
          <div class="flex-1">
            <label class="block text-xs text-gray-600 mb-1">{{ 'guard-shift-details.finish.checkin-label' | translate
              }}</label>
            <input type="time" [(ngModel)]="correctionCheckinTime"
              class="w-full px-3 py-2 !text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
          </div>
          <div class="flex items-center justify-center pb-2">
            <span class="text-gray-400">→</span>
          </div>
          <div class="flex-1">
            <label class="block text-xs text-gray-600 mb-1">{{ 'guard-shift-details.finish.checkout-label' | translate
              }}</label>
            <input type="time" [(ngModel)]="correctionCheckoutTime"
              class="w-full px-3 py-2 !text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-2">
          <button (click)="saveCorrectedTimeReport()"
            class="flex-1 inline-flex items-center justify-center px-3 py-2 rounded-md text-sm font-medium transition-colors"
            style="background: #2563eb; color: white;" onmouseover="this.style.background='#1d4ed8'"
            onmouseout="this.style.background='#2563eb'">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            {{ 'guard-shift-details.finish.save' | translate }}
          </button>
          <button (click)="cancelCorrectionPopup()"
            class="flex-1 inline-flex items-center justify-center px-3 py-2 rounded-md text-sm font-medium transition-colors"
            style="background: white; border: 1px solid #d1d5db; color: #6b7280;"
            onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='white'">
            {{ 'guard-shift-details.finish.cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Bottom spacer for mobile scroll -->
  <div class="h-[20px] sm:h-[10px] flex-shrink-0"></div>
</div>

<canvas id="confetti-canvas" style="
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 1050;
"></canvas>